export default "__VITE_ASSET__a4ac2f4b__"